import { useApiContext } from "@/contexts/ApiContext";

export function useAccountApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.accountApi;
}

export function useAnnouncementApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.announcementApi;
}

export function useContentApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.contentApi;
}

export function useCommunicationApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.communicationApi;
}

export function useCredentialApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.credentialApi;
}

export function useDefinitionsApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.definitionsApi;
}

export function useDocumentApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.documentApi;
}

export function useFirmApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.firmApi;
}

export function useFormApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.formApi;
}

export function useClientApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.clientApi;
}

export function useCaseApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.caseApi;
}

export function useCaseFileApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.caseFileApi;
}

export function useObjectionApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.objectionApi;
}

export function useUserApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.userApi;
}

export function useStripeApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.stripeApi;
}

export function useTagApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.tagApi;
}

export function useJurisdictionApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.jurisdictionApi;
}

export function useProductionSetApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.productionSetApi;
}

export function useDocumentAdminApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.documentAdminApi;
}

export function useReportsApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.reportsApi;
}

export function useInternalReportsApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.internalReportsApi;
}

export function useUserNotificationApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.userNotificationApi;
}

export function useVaultApi() {
  const context = useApiContext();
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context.vaultApi;
}
